import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { useWorkflowExecution } from "../../context/WorkflowExecutionContext";
import { AlertTriangle, X } from "lucide-react";
import { useState } from "react";

export default function AutomationUsageBanner() {
    const { t } = useTranslation();
    const { usageWarning } = useWorkflowExecution();
    const navigate = useNavigate();
    const location = useLocation();
    const [dismissed, setDismissed] = useState(false);

    if (!usageWarning || dismissed) return null;

    const { status, usage, limit } = usageWarning;
    const percentage = limit ? Math.round((usage / limit) * 100) : 0;

    const isCritical = status === "grace" || status === "throttled" || status === "blocked";
    const bgClass = isCritical
        ? "bg-red-50 border-red-200"
        : "bg-amber-50 border-amber-200";
    const textClass = isCritical ? "text-red-700" : "text-amber-700";
    const iconClass = isCritical ? "text-red-500" : "text-amber-500";
    const btnClass = isCritical
        ? "text-red-700 bg-red-100 hover:bg-red-200"
        : "text-amber-700 bg-amber-100 hover:bg-amber-200";

    return (
        <div className={`flex items-center gap-2 px-3 py-1.5 border-b text-xs ${bgClass}`}>
            <AlertTriangle size={14} className={`flex-shrink-0 ${iconClass}`} />
            <span className={textClass}>
                {t("common.automationUsageBanner.message", { usage, limit, percentage })}
            </span>
            <button
                onClick={() => {
                    localStorage.setItem("billing_return_url", location.pathname + location.search);
                    navigate("/billing");
                }}
                className={`ml-auto px-2 py-0.5 rounded text-xs font-medium ${btnClass}`}
            >
                {t("common.automationLimitReached.upgradePlan")}
            </button>
            <button onClick={() => setDismissed(true)} className={`p-0.5 rounded hover:bg-black/5 ${textClass}`}>
                <X size={12} />
            </button>
        </div>
    );
}
